import { IntervalOutput } from 'services/device/domain/business/common/Output';
import { LabelRenderer } from 'services/device/presentation/ui/widget/label-renderer/LabelRenderer';
import { IntervalOutputValueRenderer } from 'services/device/presentation/ui/widget/output-value-renderer/IntervalOutputValueRenderer';

export interface IntervalOutputProps {
	output: IntervalOutput;
}

export const IntervalOutputRenderer = (props: IntervalOutputProps): JSX.Element => {
	const { output } = props;

	return (
		<li key={output.getName()}>
			<strong>
				<LabelRenderer output={output} />
			</strong>
			<p>
				<IntervalOutputValueRenderer output={output} />
			</p>
		</li>
	);

};
